export class CompanySwitchStrategy {
  public switchCompany: (orgGuid: string | null, companyId?: string) => void;
}
